import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { Asset } from '@/types/asset';
type BlendVisionVideoData = Asset['video'] | {
  dashUri?: string;
  hlsUri?: string;
  playbackToken?: string;
} | null | undefined;
export const useBlendVisionSources = video => {
  const $ = _c(7);
  let t0;
  bb0: {
    if (!video) {
      t0 = null;
      break bb0;
    }
    const {
      dashUri,
      hlsUri,
      playbackToken
    } = video;
    if (!dashUri || !hlsUri || !playbackToken) {
      t0 = null;
      break bb0;
    }
    let t1;
    if ($[0] !== dashUri) {
      t1 = {
        type: "dash",
        src: dashUri
      };
      $[0] = dashUri;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== hlsUri) {
      t2 = {
        type: "hls",
        src: hlsUri
      };
      $[2] = hlsUri;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    let t3;
    if ($[4] !== t1 || $[5] !== t2) {
      t3 = [t1, t2];
      $[4] = t1;
      $[5] = t2;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    t0 = t3;
  }
  return t0;
};